import { updateItemInCollection } from "directus/src/operations";

export async function updateTestimonial({ item, testimonialId }) {
  try {
    const data = await updateItemInCollection("testimonials", testimonialId, item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
